module.exports = __webpack_public_path__ + "img/prize-04.69be3a18.png";